import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TeamLeadAssignment {
    id: string;
    teamId: string;
    festId: string;
    teamName: string;
    teamCode?: string;
    teamColor?: string;
    festName: string;
    festLogo?: string;
    festStatus?: string;
    festStartDate?: string;
    festEndDate?: string;
}

interface TeamLeadState {
    assignments: TeamLeadAssignment[];
    selectedAssignment: TeamLeadAssignment | null;
}

const initialState: TeamLeadState = {
    assignments: [],
    selectedAssignment: null,
};

const teamLeadSlice = createSlice({
    name: 'TeamLead',
    initialState,
    reducers: {
        setAssignments: (state, action: PayloadAction<TeamLeadAssignment[]>) => {
            state.assignments = action.payload;
            // If previously selected assignment no longer exists in the new list, clear it
            if (state.selectedAssignment) {
                const stillValid = action.payload.some(
                    a => a.teamId === state.selectedAssignment!.teamId && a.festId === state.selectedAssignment!.festId
                );
                if (!stillValid) {
                    state.selectedAssignment = null;
                }
            }
        },
        setSelectedAssignment: (state, action: PayloadAction<TeamLeadAssignment>) => {
            state.selectedAssignment = action.payload;
        },
        clearSelectedAssignment: (state) => {
            state.selectedAssignment = null;
        },
        clearTeamLeadState: (state) => {
            state.assignments = [];
            state.selectedAssignment = null;
        },
    },
});

export const { setAssignments, setSelectedAssignment, clearSelectedAssignment, clearTeamLeadState } = teamLeadSlice.actions;
export default teamLeadSlice.reducer;
